<div class="workflow-plans-grid-wrapper h-100">
  <div class="np-scrollable h-100">
    <dx-data-grid
        class="h-100 workflow-plans-grid"
        [dataSource]="workflowPlans"
        keyExpr="id"
        [allowColumnResizing]="true"
        [customizeColumns]="customizeColumns"
        [editing]="{
        allowUpdating: true,
        allowDeleting: true,
        mode: 'cell'
      }"
        (onRowRemoving)="deleteWorkflowplan($event)"
        noDataText="{{ 'keine Workflowpläne vorhanden' | translate }}"
        [showBorders]="true"
    >

      <dxi-column
          dataField="workflowId"
          caption="{{ 'Workflow' | translate }}"
          cellTemplate="workflowTemplate"
          editCellTemplate="workflowTemplate"
      ></dxi-column>

      <dxi-column
          [calculateCellValue]="getAppointmentString"
          caption="{{ 'Zeitplan' | translate }}"
          [allowEditing]="false"
      ></dxi-column>

      <dxi-column
          [calculateCellValue]="getLastRunValue"
          caption="{{ 'Letzte automatische Ausführung' | translate }}"
          [allowEditing]="false"
      ></dxi-column>

      <dxi-column
          dataField="executionCounter"
          caption="{{ 'Ausführungen' | translate }}"
          [allowEditing]="false"
      ></dxi-column>

      <dxi-column caption="{{ 'Aktiv' | translate }}" [allowEditing]="true" cellTemplate="activeStatusTemplate"
                  editCellTemplate="activeStatusTemplate"></dxi-column>

      <dxi-column editCellTemplate="diffCellTemplate">
        <div *dxTemplate="let data of 'diffCellTemplate'">
          <dx-button
              style="text-align: right; float: right"
              text="{{ 'Manuell ausführen' | translate }}"
              (onClick)="run(data)"
              icon="redo"
              stylingMode="outlined"
              type="default"
          ></dx-button>
        </div>
      </dxi-column>

      <dxi-column type="buttons">
        <dxi-button
            text="{{ 'Zeitplan' | translate }}"
            icon="clock"
            [onClick]="createUpdateDeleteWorkflowPlan"
        ></dxi-button>
        <dxi-button icon="trash" name="delete"></dxi-button>
      </dxi-column>

      <div *dxTemplate="let column of 'workflowTemplate'">
        <dx-select-box
            [items]="workflows"
            [(value)]="column.data.workflowId"
            displayExpr="name"
            valueExpr="id"
            (onValueChanged)="updateWorkflowId($event, column.data)"
        >
        </dx-select-box>
      </div>

      <div *dxTemplate="let column of 'activeStatusTemplate'">
        <dx-check-box [(value)]="column.data.active"
                      (onValueChanged)="updateWorkflowActiveStatus($event, column.data)">
        </dx-check-box>
      </div>

    </dx-data-grid>
  </div>

  <footer class="np-footer">
    <dx-button
        stylingMode="outlined"
        type="default"
        text="{{ 'Neuen Workflowplan anlegen' | translate }}"
        (onClick)="createNewWorkflowPlan()"
        hint="{{ 'Neuen Workflowplan anlegen' | translate }}"
    ></dx-button>
  </footer>

  <dx-popup
      [(visible)]="schedulerVisible"
      contentTemplate="popupContent"
      [hideOnOutsideClick]="true"
      [showCloseButton]="true"
      (onShown)="handlePopupShown()"
  >
    <div *dxTemplate="let data of 'popupContent'">
      <dx-scheduler
          #workflowPlanScheduler
          [dataSource]="appointmentData"
          [timeZone]="'UTC'"
          [views]="['month']"
          currentView="month"
          [startDayHour]="9"
          [height]="730"
          (onAppointmentAdded)="onAppointmentAdded($event)"
          (onAppointmentDeleted)="onAppointmentDeleted($event)"
          (onAppointmentUpdated)="onAppointmentUpdated($event)"
          (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
      >
      </dx-scheduler>
    </div>
  </dx-popup>

</div>
